import React from 'react';
import moment from 'moment';

import {useForceUpdate, useInterval} from '../../../../misc/hooks';
import {useI18n} from '../../../../data/hooks/i18nHooks';
import ExternalLinkButton from '../../../elements/Button/ExternalLinkButton/ExternalLinkButton';
import Time from './Time';

const WaitingRoomTimer = props => {
    const {event, currentSession, nextSession} = props,
        activeSession = currentSession || nextSession,
        i18n = useI18n(),
        now = moment(),
        // countDown = moment(activeSession.start_utc).diff(now, 'seconds'),
        buttonProps = {
            ...activeSession,
            eventId: event.id,
            primary_color: event.settings.primary_color,
            programId: activeSession.id,
        },
        forceUpdate = useForceUpdate();

    useInterval(forceUpdate, 200);

    return (
        <div className={['WaitingRoomTimer text-center', buttonProps.session_content_url ? 'has-button':''].join(' ')} data-session-in-progress={!!currentSession}>
            <h2>{currentSession ? currentSession.name : i18n['label.countdown']}</h2>
            <Time timestamp={activeSession.start_utc} i18n={i18n} primary_color={event.settings.primary_color} />
            <ExternalLinkButton {...buttonProps} style={{backgroundColor: event.settings.primary_color}} />
        </div>
    );
};
export default WaitingRoomTimer;
